import React, { Component } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

const Container = styled.div`
  padding-top: 3rem;
  padding-bottom: 1rem;
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 2rem;
  font-size: 2rem;
  background-color: #fa5856;
  padding: 1rem;
  color: #fff;
  font-size: 2.5rem;
`;

const Point = styled.p`
  margin-bottom: 0px;
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
`;

class Notice extends Component {
  render() {
    return (
      <Container className="container">
        <div className="row">
          <div className="col-md-8 offset-md-2">
            <Title>
              <FormattedMessage id="Notice.Title" />
            </Title>
            <Point>
              <FormattedMessage id="Notice.Point1" />
            </Point>
            <Point>
              <FormattedMessage id="Notice.Point2" />
            </Point>
            <Point>
              <FormattedMessage id="Notice.Point3" />
            </Point>
            <Point>
              <FormattedMessage id="Notice.Point4" />
            </Point>
            <Point>
              <FormattedMessage id="Notice.Point5" />
            </Point>
            <Point>
              <FormattedMessage id="Notice.Point6" />
            </Point>
            <Point>
              <FormattedMessage id="Notice.Point7" />
            </Point>
            <Point>
              <FormattedMessage id="Notice.Point8" />
            </Point>
            <Point>
              <FormattedMessage id="Notice.Point9" />
            </Point>
            <Point>
              <FormattedMessage id="Notice.Point10" />
            </Point>
            <Point>
              <FormattedMessage id="Notice.Point11" />
            </Point>
            <Point>
              <FormattedMessage id="Notice.Point12" />
            </Point>
            <Point>
              <FormattedMessage id="Notice.Point13" />
            </Point>
            <Point>
              <FormattedMessage id="Notice.Point14" />
            </Point>
            <Point>
              <FormattedMessage id="Notice.Point15" />
            </Point>
            <Point>
              <FormattedMessage id="Notice.Point16" />
            </Point>
            <Point>
              <FormattedMessage id="Notice.Point17" />
            </Point>
            <Point>
              <a
                href="https://www.oakhouse.jp/mypage/agreement"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.oakhouse.jp/mypage/agreement
              </a>
            </Point>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-md-8 offset-md-2">
            <div className="d-flex">
              <h6 style={{ fontWeight: 100 }}>
                <FormattedMessage id="Notice.ContactTitle" />
              </h6>
              &nbsp;
              <h6>
                <a href="mailto:competition@oakhouse.jp">competition@oakhouse.jp</a>
              </h6>
            </div>
          </div>
        </div>
      </Container>
    );
  }
}

export default Notice;
